import React, { useState } from 'react'

import './styles.scss'
import { FileSelectorButton, SelectWithLabel } from 'components/Form'
// import TextInputField from 'components/Form/TextInputField'
import { lang } from 'utils/helpers'
import SourceStatus from '../SourceStatus'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'
import ModalDelete from 'components/ModalDelete'
import { botConsoleGenerativeAPI } from 'api'

const SourceItem = ({ source, consoleId, loading, onChange, handleRemoveFromList }) => {
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const isCurrentlySaved = !!source.path
  const selectorOptions = [
    { value: 'pdf', label: lang('dashboard_document-pdf') },
  ]

  const toggleDeleteModal = () => setIsOpenDeleteModal(prevState => !prevState)

  const handleDelete = () => {
    setIsDeleting(true)
    botConsoleGenerativeAPI.deleteResource({ consoleId, resourceId: source._id })
      .then(async () => {
        setTimeout(() => {
          toggleDeleteModal()
          handleRemoveFromList(source._id)
        })
        await botConsoleGenerativeAPI.hasUpdatedResources(consoleId)
      })
      .catch(() => setErrorMsg('dashboard_couldnt-delete-source'))
      .finally(() => {
        setIsDeleting(false)
      })
  }

  return (
    <div className='generated-responses-source-item'>
      <SelectWithLabel
        classNameWrapper='generated-responses-source-item__selector'
        options={selectorOptions}
        value={selectorOptions.find(({ value }) => value === source.type)}
        onChange={({ value: type }) => onChange({ type })}
        isDisabled={isCurrentlySaved}
      />
      {
        source.type === 'pdf'
          ? (
            <FileSelectorButton
              acceptedTypes='application/pdf'
              disabled={isCurrentlySaved}
              value={source}
              onChange={value => onChange({ value })}
            />
          )
          : null
      }
      <div className='generated-responses-source-item__actions'>
        <SourceStatus status={source.state} />
        {loading ? (
          <Nixi1Spinner width='15px' height='15px' />
        ) : (
          <button
            className='generated-responses-source-item__icon-btn'
            title={lang('dashboard_delete')}
            onClick={() => !source.temp
              ? toggleDeleteModal()
              : handleRemoveFromList(source._id)
            }
          >
            <figure>
              <img src={getStaticImage('/icons/icon-delete.svg')} alt='Delete' />
            </figure>
          </button>
        )}
      </div>

      {/* Delete modal */}
      <ModalDelete
        isOpen={isOpenDeleteModal}
        toggle={toggleDeleteModal}
        event={handleDelete}
        header={lang('dashboard_delete-source')}
        text1={lang('dashboard_sure-want-delete-font')}
        text2={lang('dashboard_process-cannot-reversed')}
        isSubmitting={isDeleting}
        errorMessage={errorMsg}
      />
    </div>
  )
}

export default SourceItem
